// Client-side mirror of backend-node/utils/collegeFit.js — kept in sync by
// hand (it's tiny) so the Profile page's verdict chips update instantly
// without a round trip, while never disagreeing with the server's numbers.

export const FIT_META = {
  Reach: { color: '#A03123', bg: '#F3DFDA', pin: '#E4735C' },
  Target: { color: '#8A5F0E', bg: '#F1E5C8', pin: '#E3B24E' },
  Likely: { color: '#3E6B44', bg: '#DFE9DA', pin: '#8FBF7F' },
};

export function deriveStats(application) {
  const sd = application.scorecardData || {};
  const manual = application.manualStats || {};
  const isUK = !!application.country && application.country !== 'US';
  const sat25 = (sd.satMath25 != null && sd.satReading25 != null)
    ? sd.satMath25 + sd.satReading25
    : null;
  const sat75 = sd.satComposite75 ??
    ((sd.satMath75 != null && sd.satReading75 != null) ? sd.satMath75 + sd.satReading75 : null);
  const admitRate = sd.admissionRate ?? manual.admitRate ?? null;
  const ibOffer = manual.ibOffer ?? null;
  return { isUK, sat25, sat75, admitRate, ibOffer };
}

export function fitFor(profile, application) {
  const { isUK, sat25, sat75, admitRate, ibOffer } = deriveStats(application);
  const ib = profile?.ibPredicted;
  const sat = profile?.satComposite;

  if (isUK || ibOffer != null) {
    if (ibOffer == null || ib == null) return null;
    if (ib >= ibOffer + 2) return 'Likely';
    if (ib >= ibOffer) return 'Target';
    return 'Reach';
  }

  if (sat == null || sat75 == null || admitRate == null) return null;
  if (sat >= sat75 && admitRate > 0.3) return 'Likely';
  if (admitRate < 0.1) return 'Reach';
  if (sat25 != null && sat >= sat25) return (sat >= sat75 && admitRate > 0.25) ? 'Likely' : 'Target';
  return 'Reach';
}
